import { useCallback } from "react";
import { NewViewTypeEnum } from "../../common/enums/NewViewTypeEnum";
import { isIOS } from "react-device-detect";
import useNavigateTo from "../use-navigate-to/useNavigateTo";

export type MapToOptions = {
    latitude?: string;
    longitude?: string;
};

export default function useMapTo(): (options: MapToOptions) => void {

    const navigateTo = useNavigateTo();


    const mapTo = useCallback((options: MapToOptions) => {

        const url = isIOS ? 
        //`http://maps.apple.com/maps?saddr=${latitude},${longitude}` : 
        // use daddr instead of saddr to get directions from current location
        // `http://maps.apple.com/maps?daddr=${options.latitude},${options.longitude}` : 
        `http://maps.apple.com/maps?q=${options.latitude},${options.longitude}` : 
        // isAndroid ?
        // `` :
         `https://www.google.com/maps/search/?api=1&query=${options.latitude},${options.longitude}`;

         navigateTo(url, {
            newViewType: NewViewTypeEnum.NewTab
         });

    }, [
        navigateTo,
    ]);

    return mapTo;
}